// extracted by mini-css-extract-plugin
export default {"container":"jp-z","bubbleNav":"kp-z","graphic":"lp-z","contact":"mp-z"};